import Utils from 'utils/Utils'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setPlataformaSelecionada } from 'store/slices/plataformaSlice'
import { getPlataforma } from 'pages/Home/HomeManager'
import { obterCodPlataformaFormatado } from 'utils/format'
import { useMenuLateral } from 'components/MenuLateral/context/MenuLateralProvider/MenuLateralProvider'

export function useRedirectPlatform() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { onMenuLateralClose, setItemSelecionado } = useMenuLateral()

  const redirecionarPlataforma = async (
    rota: string,
    isPlatform?: boolean,
    isPersonalizado?: boolean
  ) => {
    if (isPlatform) {
      const codPlataforma = rota.split('/')[2]
      const plataformaCarregada = await getPlataforma(codPlataforma)
      if (
        (!Utils.isLocalhost() &&
          location.host == process.env.REACT_APP_DEFAULT_DNS &&
          plataformaCarregada.nomeHost) ||
        (plataformaCarregada.nomeHost &&
          location.host != plataformaCarregada.nomeHost)
      ) {
        location.href = `https://${plataformaCarregada.nomeHost}${rota}`
        setItemSelecionado(rota)
        onMenuLateralClose()
      } else {
        dispatch(
          setPlataformaSelecionada({
            ...plataformaCarregada,
            nome:
              plataformaCarregada.nome ||
              obterCodPlataformaFormatado(plataformaCarregada.codigo)
          })
        )
      }
      setItemSelecionado(rota)
      navigate(rota, { state: { menuPersonalizado: isPersonalizado } })
      onMenuLateralClose()
    } else {
      if (rota == '/home') {
        const rota = window.location.origin + '/home'
        location.href = rota
        onMenuLateralClose()
      } else {
        setItemSelecionado(rota)
        navigate(rota, { state: { menuPersonalizado: isPersonalizado } })
        onMenuLateralClose()
      }
    }
  }

  return { redirecionarPlataforma }
}
